<template>
  <div class="header">
    <div
      v-if="!embedHeader"
      class="header__top"
    >
      <div class="header__navigation">
        <router-link :to="'/search?' + $store.getters['search/getFiltersQuery']('search', 'client') + $store.getters['search/getControlsQuery'](type, 'client')" class="link--blue_alt">App</router-link>
        <span> / </span>
        <router-link :to="'/' + type + '?' + $store.getters['search/getFiltersQuery']('search', 'client') + $store.getters['search/getControlsQuery'](type, 'client')" class="link--blue_alt">{{ resourceName }}</router-link>
        <span> / </span>
        <router-link :to="'/' + type + '/' + resourceId" class="link--white_altB">{{ resourceId }}</router-link>
        <span :class="['tag', licensed === true ? 'tag--unlocked' : 'tag--locked']">{{ licensed === true ? 'Unlocked' : 'Locked' }}</span>
      </div>

      <div class="header__close">
        <router-link :to="closeUrl" class="link--white">{{ !comingFrom ? 'Close' : 'Back' }}</router-link>
      </div>
    </div>

    <div class="header__bottom">
      <div
        v-if="!embedHeader"
        class="header__left"
      >
        <div
          :class="['header__logo', 'header__logo--' + type]"
          v-html="logo"
        />

        <div class="header__title">
          <h1 v-html="highlight(title, filterWords)" :title="title" />
        </div>
      </div>

      <UtilityScroll v-else class="header__scroll">
        <div class="header__embedTitle">
          <h1>
            <router-link target="_blank" :to="'/' + type + '/' + resourceId" class="link--white">
              {{ title }}
            </router-link>
          </h1>
        </div>
      </UtilityScroll>

      <div
        v-if="!embedHeader"
        :class="['header__right', licensed === false ? 'header__right--mobileLocked' : 'header__right--mobileUnlocked', licensed === false ? 'header__right--active' : '']"
        @mouseover.prevent="statusActive = true"
        @mouseout.prevent="statusActive = false"
        @click="itemClicked"
      >
        <div class="header__status">
          <div v-if="downloaded">
            <div
              class="list__icon list__icon--md list__icon--blue"
              :content="'Last downloaded @ ' + formatDate(downloaded)"
              v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
            >
              <div class="header__statusIcon">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 21l-8-9h6v-12h4v12h6l-8 9zm9-1v2h-18v-2h-2v4h22v-4h-2z"/></svg>
              </div>
              <div class="header__statusText">{{ formatDate(downloaded) }}</div>
            </div>
          </div>

          <div v-else-if="viewed">
            <div
              class="list__icon list__icon--md list__icon--blue"
              :content="'Last viewed @ ' + formatDate(viewed)"
              v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
            >
              <div class="header__statusIcon">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"/></svg>
              </div>
              <div class="header__statusText">{{ formatDate(viewed) }}</div>
            </div>
          </div>
        </div>

        <p v-html="contentText.text" />

        <FormButton
          v-if="licensed === false"
          variant="white"
          :text="contentText.urlText"
          :textOnly="true"
          :borderless="true"
          :selected="false"
          :disabled="false"
          style="margin: 8px 0px;"
        />
      </div>
    </div>

    <div v-if="!embedHeader" :class="['header__effect', licensed === true ? 'header__effect--unlocked' : 'header__effect--locked', statusActive ? 'header__effect--active' : '']"></div>

    <div v-if="!embedHeader" :class="['header__lock', statusActive ? 'header__lock--active' : '']">
      <svg v-if="licensed === false" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M10 16c0-1.104.896-2 2-2s2 .896 2 2c0 .738-.404 1.376-1 1.723v2.277h-2v-2.277c-.596-.347-1-.985-1-1.723zm11-6v14h-18v-14h3v-4c0-3.313 2.687-6 6-6s6 2.687 6 6v4h3zm-13 0h8v-4c0-2.206-1.795-4-4-4s-4 1.794-4 4v4zm11 2h-14v10h14v-10z"/></svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12.451 17.337l-2.451 2.663h-2v2h-2v2h-6v-5l6.865-6.949c1.08 2.424 3.095 4.336 5.586 5.286zm11.549-9.337c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-3-3c0-1.104-.896-2-2-2s-2 .896-2 2 .896 2 2 2 2-.896 2-2z"/></svg>
    </div>
  </div>
</template>

<script>
import FormButton from '@/components/form/Button.vue'
import UtilityScroll from '@/components/utility/Scroll.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    FormButton,
    UtilityScroll
  },
  props: {
    title: {
      type: String
    },
    type: {
      type: String,
      default: 'datasets',
      validator (values) {
        return ['datasets', 'pdfs'].includes(values)
      }
    },
    embedHeader: {
      type: Boolean,
      default: false
    },
    resourceId: {
      type: String
    },
    licensed: {
      type: Boolean,
      default: false
    },
    trial: {
      type: Boolean,
      default: false
    },
    free: {
      type: Boolean,
      default: false
    },
    viewed: {
      type: [Boolean, String],
      default: false
    },
    downloaded: {
      type: [Boolean, String],
      default: false
    },
    logo: {
      type: String
    },
    filterWords: {
      type: Array,
      default: []
    },
    topics: {
      type: Array,
      default: []
    },
    locationId: {
      type: String,
      default: ''
    },
    based: {
      type: String
    },
    comingFrom: {
      type: [Boolean, String]
    }
  },
  data () {
    return {
      statusActive: false,
      regionalLocations: ['QPo','MJO','NNe','52x','oqq','vd8','JqJ','9Oe','mVo','qmG','VPA','eXO','7JD','k7K','gAY','wVl','jmV','Xdq','noD','31Q','aeA','dGB','pAB','noD','yEK','z9a','DEN']
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    resourceName () {
      if (this.type === 'datasets') {
        return 'Datasets'
      } else if (this.type === 'pdfs') {
        return 'Reports'
      }
    },
    contentText () {
      let subscriptionStatus = this.$store.getters['user/getSubscriptionStatus']
      let text = 'This content is not included in your license.'
      let urlText = 'Contact sales'
      let url = 'https://statzon.com/contact-us'
      let local = false

      if ((subscriptionStatus === 'guest' || subscriptionStatus === 'free') && this.licensed === false) {
        if (this.type === 'datasets') {
          text = 'Unlock this dataset with <span class="highlight">dataset subscription</span>.'
          urlText = 'Unlock'
          url = 'https://statzon.com/individual-data-license'
          local = false

          if (this.locationId === '6rM') {
            text = 'Unlock this dataset with <span class="highlight">free subscription</span>.'
            urlText = 'Sign up'
            url = '/register'
            local = true
          }
        } else if (this.type === 'pdfs') {
          text = 'Unlock this report with <span class="highlight">Statzon subscription</span>.'
          urlText = 'Unlock'
          url = 'https://statzon.com/pricing'
          local = false
        }
      } else if (this.isAuthenticated === true && this.licensed === true) {
        text = 'This content is included in your license.'
        urlText = false
        url = false
        local = false
      }

      return {
        'text': text,
        'urlText': urlText,
        'url': url,
        'local': local
      }
    },
    closeUrl () {
      let searchView = 'search'

      if (this.comingFrom === 'Datasets') {
        searchView = 'datasets'
      } else if (this.comingFrom === 'PDFs') {
        searchView = 'pdfs'
      }

      return '/' + searchView + '?' + this.$store.getters['search/getFiltersQuery'](false, false) + this.$store.getters['search/getControlsQuery'](searchView, 'client')
    },
  },
  methods: {
    itemClicked () {
      if (this.licensed === false) {
        if (this.contentText.url && this.contentText.url !== false) {
          helperMethods.sendGoogleAnalyticsEvent('cta_click', this.title, this.contentText.url, this.$store.getters['user/getSubscriptionStatus'])
        }

        if (this.contentText.local === true) {
          this.$router.push(this.contentText.url)
        } else {
          window.open(this.contentText.url, '_blank')
        }
      }
    },
    ...helperMethods
  },
  mounted () {
    if (this.contentText.url && this.contentText.url !== false && this.contentText.url !== '/settings/licenses') {
      helperMethods.sendGoogleAnalyticsEvent('cta_view', this.title, this.contentText.url, this.$store.getters['user/getSubscriptionStatus'])
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.header {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  background-color: $bg-2;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23272b2f' fill-opacity='0.7' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E");
  width: 100%;

  @media screen and (min-width: $breakpointMd) {
    //flex-direction: column;
  }

  &__top {
    display: flex;
    align-items: center;
    width: 100%;
    height: 36px;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;
    padding: 0;
    background-color: rgba($bg-2, 0.5);

    @media screen and (min-width: $breakpointLg) {
      height: 40px;
    }
  }

  &__bottom {
    display: flex;
    flex-direction: column;
    //min-height: 112px;
    //height: auto;
    width: 100%;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;

    @media screen and (min-width: $breakpointMd) {
      flex-direction: row;
    }

    @media screen and (min-width: $breakpointLg) {
      //min-height: 130px;
    }
  }

  &__left {
    width: auto;
    padding: 0.5rem 0;
    flex: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid $black;

    @media screen and (min-width: $breakpointMd) {
      border-bottom: none;
    }
  }

  &__right {
    max-width: auto;
    width: calc(100% - 32px);
    min-height: auto; // TEMP: Remove afte you add "show licenses" button
    padding: 1rem 16px;
    border-top: 1px solid rgba($white, 0.1);
    align-self: center;
    text-align: center;

    &--mobileLocked {
      background: rgba($red, 0.35);
    }

    &--mobileUnlocked {
      background: rgba($green, 0.4);
    }

    @media screen and (min-width: $breakpointMd) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: none;
      max-width: 260px;
      width: 260px;
      padding: 0.5rem 16px;
      border-top: none;
      min-height: 71px; // TEMP: Remove afte you add "show licenses" button
    }

    @media screen and (min-width: $breakpointLg) {
      background: none;
      max-width: 300px;
      width: 300px;
    }

    &:hover {
      @media screen and (min-width: $breakpointMd) {
       // background: none;
      }
    }

    &--active {
      cursor: pointer;
    }

    p {
      @include font('content--md', $white, 0.9);
      font-weight: 500;
      text-align: center;
      margin: 0;
      position: relative;
      z-index: 2;

      @media screen and (min-width: $breakpointMd) {
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin: 0;
      }

      @media screen and (min-width: $breakpointLg) {
        @include font('content--lg', $white, 0.9);
        font-weight: 500;
        margin: 0;
      }

      /deep/ span {
        color: rgba($white, 0.9);
        border-bottom: 1px dashed $white !important;
      }
    }
  }

  &__scroll {
    height: 102px;

    @media screen and (min-width: $breakpointSm) {
      height: 68px;
    }

    @media screen and (min-width: $breakpointLg) {
      height: 92px;
    }
  }

  &__status {
    @include font('content--xs', $white, 0.8);
    position: absolute;
    top: 40px;
    right: 16px;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--sm', $white, 0.8);
      top: 44px;
    }

    div {
      display: flex;
      justify-content: right;
      align-items: center;
    }

    &Icon {
      display: flex;
      //background-color: $bg-2;
      border-radius: 99px;
      width: 14px;
      height: 14px;
      margin-right: 4px;

      @media screen and (min-width: $breakpointLg) {
        width: 18px;
        height: 18px;
        margin-right: 6px;
      }
    }

    svg {
      width: 14px;
      height: 14px;
      fill: rgba($white, 0.5);

      @media screen and (min-width: $breakpointLg) {
        width: 14px;
        height: 14px;
      }
    }
  }

  &__navigation {
    flex: 1;
    margin: 0 16px;
    color: rgba($white, 0.7);
  }

  &__close {
    margin: 0 16px;
  }

  &__logo {
    display: none;
    position: relative;
    z-index: 2;
    width: 50px;
    min-width: 50px;
    max-width: 50px;
    height: 50px;
    fill: rgba($white, 0.9);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    padding: 10px;
    margin: 8px 32px 8px 16px;
    box-shadow: 0 2px 1px -1px rgba($black, 0.5), 0 1px 1px 0 rgba($black, 0.5), 0 1px 3px 0 rgba($black, 0.25);
    border-radius: 4px;

    @media screen and (min-width: $breakpointSm) {
      display: block;
    }

    &--datasets {
      background-color: rgba($blue, 0.75);
    }

    &--pdfs {
      background-color: rgba($red, 0.75);
    }
  }

  &__title {
    text-align: center;
    align-self: center;
    margin: 0 16px 0 16px;

    @media screen and (min-width: $breakpointSm) {
      margin: 0 32px 0 0;
      text-align: left;
    }

    @media screen and (min-width: $breakpointMd) {
      margin: 0 32px 0 0;
    }

    h1 {
      @include font('header--sm');

      @media screen and (min-width: $breakpointMd) {
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      @media screen and (min-width: $breakpointLg) {
        @include font('header--md');
      }
    }
  }

  &__embedTitle {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 16px 0 16px;
    min-height: 102px;

    @media screen and (min-width: $breakpointSm) {
      min-height: 68px;
    }

    @media screen and (min-width: $breakpointLg) {
      min-height: 92px;
    }

    h1 {
      @include font('header--sm');

      @media screen and (min-width: $breakpointLg) {
        @include font('header--md');
      }
    }
  }

  /*&__name {
    h1 {
      @include font('header--md');
      width: calc(100% - 48px);

      @media screen and (min-width: $breakpointLg) {
        @include font('header--lg');
      }
    }
  }*/

  /deep/ &__based {
    p {
      color: rgba($white, 0.7);
      margin: 0;
    }

    span {
      color: rgba($white, 0.9);
    }
  }

  &__effect {
    opacity: 0;
    position: absolute;
    overflow: hidden;
    user-select: none;
    width: 270px;
    top: 0;
    right: 0;
    border-style: solid;
    border-width: 0 0 240px 75px;
    z-index: -2;

    @media screen and (min-width: $breakpointMd) {
      opacity: 1;
      transition: all 0.4s ease-out;
    }

    @media screen and (min-width: $breakpointLg) {
      width: 310px;
    }

    &--locked {
      border-color: transparent transparent rgba($red, 0.35) transparent;
    }

    &--unlocked {
      border-color: transparent transparent rgba($green, 0.4) transparent;
    }
  }

  &__lock {
    position: absolute;
    display: none;
    left: 0px;
    bottom: 10px;
    right: unset;
    height: 90px;
    width: auto;
    fill: $bg-2;
    z-index: 1;
    transition: all 0.25s ease-out;

    &--active {
      transform: scale(1.1);
      left: 0px;
      right: unset;
    }

    @media screen and (min-width: $breakpointMd) {
      display: block;
      left: unset;
      bottom: 8px;
      right: 210px;
      height: 130px;
      z-index: -1;

      &--active {
        transform: scale(1.05);
        left: unset;
        right: 205px;
      }
    }

    @media screen and (min-width: $breakpointLg) {
      right: 250px;
      bottom: 12px;

      &--active {
        transform: scale(1.05);
        left: unset;
        right: 245px;
      }
    }
  }
}

.tag {
  @include font('content--xs', $white, 1);
  position: relative;
  top: -1px;
  border-radius: 4px;
  font-weight: 500;
  text-transform: uppercase;
  margin-left: 8px;
  padding: 1px 4px;

  &--locked {
    background-color: rgba($red, 0.4);
  }

  &--unlocked {
    background-color: rgba($green, 0.4);
  }
}

</style>
